// extracted by mini-css-extract-plugin
export default {"root":"_6Ql56","link-overlay":"_11__P","linkOverlay":"_11__P"};